import * as React from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { routeConstants } from 'app/routes/route-constants';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { STATE } from 'app/constants';
import { containerFactory } from 'app/infrastructure/redux';
import { actionCreators } from './actions';
import { CaseDraftInfoState } from './types';
import { insertLink } from './insert-link';
import styles from './case-draft-count-panel.scss';

export interface CaseDraftCountPanelOwnProps {
  textSubtitle: string;
  textCase: string;
  textCases: string;
}

type CaseDraftCountPanelProps = CaseDraftInfoState & CaseDraftCountPanelOwnProps & typeof actionCreators;

const CaseDraftCountPanelComponent: React.FC<CaseDraftCountPanelProps> & { statePath?: string } = ({
  textSubtitle,
  textCase,
  textCases,
  count,
  fetching,
  loadDraftsData
}) => {
  useEffect(() => {
    loadDraftsData();
  }, []);

  if (fetching || !count) {
    return null;
  }

  const formattedLink = replaceTemplateString(count === 1 ? textCase : textCases, count);
  const link = <Link to={routeConstants.myCaseDraftsView}>{formattedLink}</Link>;

  return <div className={styles.description}>
    {insertLink(textSubtitle, [link])}
  </div>;

};

CaseDraftCountPanelComponent.statePath = STATE.caseDraftInfo;

export const CaseDraftCountPanel = containerFactory<CaseDraftCountPanelOwnProps>(
  CaseDraftCountPanelComponent,
  actionCreators,
  null,
  null
);
